/* Shared by the Treatment page and the treatment preview grid on Home. */

export const TREATMENTS = [
  {
    id: 1,
    title: 'Thai Massage',
    summary: 'Pressure points, stretching and joint mobilisation — no oil.',
    image: '/images/Thai_Massage.jpg',
    description:
      'Traditional Thai Massage is performed without massage oil. The therapist uses the palms, thumbs and elbows to work on key pressure points, combined with stretching and gentle mobilisation of the main joints. This style effectively promotes circulation of the venous blood and lymphatic systems, helping to unblock problem areas and relieve pain.',
  },
  {
    id: 2,
    title: 'Relaxing Oil Massage',
    summary: 'Long, slow gliding strokes for full-body relaxation.',
    image: '/images/Relaxing_Oil_Massage.jpg',
    description:
      'A relaxing full-body massage using long, slow but firm techniques to provide a gradual, soothing treatment. Smooth gliding strokes assist the circulation of venous blood and the lymphatic system, leaving you feeling deeply relaxed and restored.',
  },
  {
    id: 3,
    title: 'Deep Tissue Massage',
    summary: 'Firm work on deeper muscle layers for strain and injury.',
    image: '/images/Deep_Tissue_Massage.jpg',
    description:
      'Drawing on both traditional Thai and Western techniques, Deep Tissue Massage firmly reaches deeper layers of muscle to address pain and injury. It is ideal for treating repetitive strains and sports injuries, promoting gradual pain relief and connective tissue repair.',
  },
  {
    id: 4,
    title: 'Hot Stone Massage',
    summary: 'Heated stones to release tension and quiet the mind.',
    image: '/images/Hot_Stone_Massage.jpg',
    description:
      'Smooth, heated stones are placed on specific parts of the body to ease muscle tension and damaged soft tissue throughout your body. Hot Stone Massage helps relieve muscle pain, reduce stress and anxiety, and promotes deeper, more restful sleep.',
  },
]
